import { isBrowser } from '~/utilities/helpers';

let injected = false;

// PCI DSS 4.0 req. 6.4.3: pages that accept cardholder data must not run
// third-party scripts whose integrity we cannot assure. HubSpot's loader is
// served from a mutable URL whose body rotates every five minutes, so it can
// never carry a subresource integrity hash. Keep it off these routes - they
// are the ones that render PaymentElementsForm.
const PAYMENT_PATH_PREFIXES = ['/checkout', '/account'];

const isPaymentPath = (pathname) =>
    PAYMENT_PATH_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    );

const doNotTrackEnabled = () =>
    window.doNotTrack === '1' ||
    navigator.doNotTrack === 'yes' ||
    navigator.doNotTrack === '1' ||
    navigator.msDoNotTrack === '1';

export const loadHubSpot = (trackingCode) => {
    if (
        !isBrowser() ||
        injected ||
        !trackingCode ||
        isPaymentPath(window.location.pathname) ||
        doNotTrackEnabled()
    ) {
        return;
    }

    injected = true;

    window._hsq = window._hsq || [];
    window._hsq.push([
        'setPath',
        window.location.pathname + window.location.search + window.location.hash
    ]);

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.id = 'hs-script-loader';
    script.src = `https://js.hs-scripts.com/${trackingCode}.js`;

    const firstScript = document.getElementsByTagName('script')[0];

    if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
    } else {
        document.head.appendChild(script);
    }
};
